import { Link } from "react-router-dom";

const Confirmation = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.code}>Thank you for your purchase!</h1>
      <h4 style={styles.gray}>Your purchase order process has now started.</h4>
      <p style={styles.message}>
        Please check your email to proceed with the payment using your preferred
        payment method. If you don't see it in your inbox, kindly check your
        spam or junk folder as well.
      </p>
      <Link to="/" style={styles.link}>
        Go back to homepage
      </Link>
    </div>
  );
};

const styles = {
  container: {
    textAlign: "center",
    padding: "4rem",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  code: {
    fontSize: "2.5rem",
    margin: "0",
    color: "#333",
  },
  message: {
    fontSize: "0.5rem",
    marginBottom: "2rem",
    color: "#666",
  },
  link: {
    fontSize: "1rem",
    textDecoration: "none",
    color: "#007bff",
    border: "1px solid #007bff",
    padding: "0.5rem 1rem",
    borderRadius: "4px",
  },

  gray: {
    margin: "0",
    color: "#333",
  },
};

export default Confirmation;
